import React from "react";
import ProjectModal from "../../../../modals/ProjectActions/ProjectModal";
import { RECEIVING_WORKFLOW_RECEIVING_ASSISTANT } from "../../../../modals/ProjectActions/projectReceivingWorkflow";
import { useLocationSnapshotAddItem } from "./hooks/useLocationSnapshotAddItem";
import LocationSnapshotAddItemStepDialog from "./LocationSnapshotAddItemStepDialog";

export default function LocationSnapshotAddItemModal(props) {
  const wizard = useLocationSnapshotAddItem(props);

  const { open, locationName } = props;

  if (!open) {
    return null;
  }

  return (
    <>
      <LocationSnapshotAddItemStepDialog open={open} locationName={locationName} wizard={wizard} />

      {wizard.openCreateProject && (
        <ProjectModal
          onClose={() => wizard.setOpenCreateProject(false)}
          onSubmit={wizard.handleCreateProject}
          autoFocus={
            localStorage.getItem("locationSnapshotAddItem_clientId") ? "projectName" : "clientId"
          }
          initialValues={{
            clientId: localStorage.getItem("locationSnapshotAddItem_clientId") || "",
            projectName: "",
            projectType: localStorage.getItem("locationSnapshotAddItem_projectType") || "",
            receivingWorkflow: RECEIVING_WORKFLOW_RECEIVING_ASSISTANT,
          }}
        />
      )}
    </>
  );
}
